import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IIncomingJob } from '../interfaces/incoming-job';
import { IIncomingJobFilter } from '../interfaces/incoming-job-filter';
import { EditService } from './edit.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class IncomingJobService extends EditService<IIncomingJob, IIncomingJobFilter> {
  url = '/api/order';
  entityTitle = 'IncomingJob';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
